import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import _ from "lodash";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import Button from "react-bootstrap-button-loader";
import renderHTML from "react-render-html";
import { addTemplate, updateTemplate, fetchTemplate, resetTemplate } from "SettingActions";
import { showError, showSuccess } from "ReduxErrorBar";
import { COMMON_FAIL_MESSAGE } from "Constants";
import GrapesEdit from "./grapes";
import LocaleStrings from "Languages";
import { confirmAlert } from "react-confirm-alert"; // Import

class ProposalResubmissionTemplate extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { loading: false, isOpen: false, section: "", id: 0 };
  }

  /* RESET THE TEMPLATE  */
  resetPushNotifications = () => {
    let template_name = 'proposal_resubmission_email.html';
    let column_name = 'proposal_resubmission_contenthtml';
    confirmAlert({
      title: 'Reset Proposal Resubmission Email',
      message: 'Are you sure you want to reset , resetting  will bring the default template back',
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.resetTemplate(
              this.props.session,
              template_name,
              column_name,
              (callback) => {
                if (callback.success === 1) {
                  this.props.showSuccess(
                    'Template Reset Successfull'
                  );
                  this.props.fetchTemplate(
                    this.props.session,
                    (callback) => { }
                  );
                } else {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                }
                this.setState({ resetBtnLoader: false });
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {
          },
        },
      ],
    });

  };


  onSubmitForm = (data) => {
    this.setState({ loading: true });
    let newdata = {};
    var values = { ...data };
    if (!this.props.insertMode) {
      newdata.proposal_resubmission_subject = data.proposal_resubmission_subject;
      newdata.id = data.id;
      newdata.eventid = data.eventid;
      //  console.log('insert');
      this.props.addTemplate(this.props.session, newdata, (response) => {
        if (response.success === 0) {
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.props.showSuccess(LocaleStrings.template_added_message);
        }
        this.setState({ loading: false });
      });
    } else {
      // console.log('update');
      this.props.updateTemplate(this.props.session, newdata, (response) => {
        if (response.success === 0) {
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.props.showSuccess(LocaleStrings.template_updated_message);
        }
        this.setState({ loading: false });
      });
    }
  };

  openModals = (section) => {
    this.setState({
      isOpen: true,
      section: section,
      id: this.props.initialValues.id,
    });
  };

  closeModals = () => {
    this.props.fetchTemplate(this.props.session);
    this.setState({ isOpen: false });
  };

  render() {
    var { handleSubmit, pristine, reset, invalid, submitting, temp_data, initialValues } =
      this.props;
    // console.log('initialValues :- ', this.props.initialValues);
    var disabled = false;
    if (pristine || invalid || submitting) {
      disabled = true;
    }
    let content = `<div style="text-align:center;margin-top:50px">No Content added<div>`;
    if (
      temp_data &&
      temp_data.proposal_resubmission_contenthtml !== null &&
      temp_data.proposal_resubmission_contenthtml !== ""
    ) {
      content = this.props.temp_data.proposal_resubmission_contenthtml;
    }

    return (
      <form onSubmit={handleSubmit(this.onSubmitForm)}>
                <div className="d-flex">
          <div className="pull-left" style={{width:'88%'}}> 
            <Field
              name="proposal_resubmission_subject"
              label={LocaleStrings.template_setting_form_label_subject}
              placeholder={LocaleStrings.template_setting_form_ph_subject}
              type="text"
              component={this.renderFieldText}
              mandatory="true"
              labelposition={LABEL_POSITION_TOP}
            />
          </div>
          <div className="" style={{marginLeft:'auto'}}>
            <Button
              style={{ marginTop: '37px' }}
              bsStyle=""
              className="btn-custom-blue save-subject-btn"
              disabled={disabled}
              loading={this.state.loading}
              type="submit"
            >
              {LocaleStrings.button_save}
            </Button>
          </div>


        </div>

        <div className="row">
          <div className="control-label-top col-md-5">
            {LocaleStrings.template_setting_form_label_email_content}
            <span className="label-mandatory">*</span>
          </div>
          <div
            className="col-md-7"
            style={{ textAlign: "end", paddingLeft: "0px" }}
          >
            <Button
              type="button"
              className="extra-button-theme btn-custom-white"
              onClick={this.resetPushNotifications}
              style={{ fontSize: 11, marginRight: '10px' }}
              title="Press Me"
            >
              {/* <i className="fa fa-refresh" aria-hidden="true"></i> */}
              <img className="reset-icon-email" aria-hidden="true" src="../../style/images/reseticon.png"></img> 
              <span className="reset-icon-text">{LocaleStrings.setting_email_template_resetbtn_text}</span>
            </Button>
            <Button
              bsStyle=""
              className="btn-custom-blue"
              onClick={() => this.openModals("proposalresubmission")}
            >
              {LocaleStrings.setting_email_template_text_edit_with_gjs}
            </Button>
            {this.state.isOpen ? (
              <GrapesEdit
                pageid={this.state.id}
                headerid={this.state.id}
                section={this.state.section}
                isOpen={this.state.isOpen}
                onClose={this.closeModals}
              />
            ) : (
              ""
            )}
          </div>
        </div>

        <div className="email-preview-box">
          <div>
            {content !== undefined && content !== null
              ? renderHTML(content)
              : null}
          </div>
        </div>
        {/* <Field
          name="proposal_resubmission_contenthtml"
          // label={LocaleStrings.template_setting_form_label_email_content}
          placeholder={LocaleStrings.template_setting_form_ph_email_content}
          type="minimal"
          component={this.renderRichTextareaWithLabelTinymce}
          // mandatory="true"
          height={500}
          labelposition={LABEL_POSITION_TOP}
        /> */}

      </form>
    );
  }
}

function validate(values) {
  var errors = {};

  var requiredFields = [
    "proposal_resubmission_subject",
    "proposal_resubmission_contenthtml",
  ];
  requiredFields.forEach((field) => {
    if (!values[field] || values[field].trim() === "") {
      errors[field] = LocaleStrings.template_setting_form_validation_required;
    }
  });

  return errors;
}

function mapStateToProps(state, props) {
  // var data= _.filter(state.templateData.resource, (obj) => {return obj.templatetype === props.type });
  // var finalData = data.length > 0 ? data[0] : {}

  var initVals = null;
  var toEdit = false;
  if (
    state.templateData &&
    state.templateData.resource &&
    state.templateData.resource.length > 0
  ) {
    initVals = state.templateData.resource[0];
    toEdit = true;
  }

  return {
    session: state.session,
    insertMode: toEdit,
    initialValues: initVals,
    temp_data: initVals
  };
}
export default connect(mapStateToProps, {
  addTemplate,
  updateTemplate,
  showError,
  showSuccess,
  fetchTemplate,
  resetTemplate
})(
  reduxForm({
    validate,
    form: "ProposalResubmissionTemplateForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(ProposalResubmissionTemplate)
);
